<!-- 图片预览 -->
<template>
  <div class="carouselBox" ref="carouselBox" @click="closePreview">
    <Carousel
      v-model="currentIndex"
      height="auto"
      class="carousellist"
      :loop="setting.loop"
      :autoplay="setting.autoplay"
      :autoplay-speed="setting.autoplaySpeed"
      :dots="setting.dots"
      :radius-dot="setting.radiusDot"
      :trigger="setting.trigger"
      :arrow="setting.arrow"
      :easing="setting.easing"
    >
      <CarouselItem class="carousellist" v-for="(item,index) in imgArr" :key="index">
        <img
          :src="item.path"
          class="carousel_img"
          :style="{height:item.isHeight?'700px':'auto',width:item.isHeight?'auto':'50%'}"
        >
      </CarouselItem>
    </Carousel>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    imgArr: Array,
    currentIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    //这里存放数据
    return {
      setting: {
        autoplay: false,
        loop: false,
        autoplaySpeed: 2000,
        dots: "inside",
        radiusDot: true,
        trigger: "click",
        arrow: "hover",
        easing:'none'
      },
      newArr: []
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    closePreview() {
      console.log("---closePreview---");
      //this.$emit('closePreview')
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    document.addEventListener("click", e => {
      // document.getElementsByClassName("classname")
      // var left = document.getElementsByClassName("ivu-carousel-arrow")[0];
      // var right = document.getElementsByClassName("ivu-carousel-arrow")[1];
      // if(!left.contains(e.target) && !right.contains(e.target)){            //这句是说如果我们点击到了id为myPanel以外的区域
      //   this.$emit('closePreview')
      // }
      if (
        e.target.className.indexOf("ivu-icon-ios-arrow-back") < 0 &&
        e.target.className.indexOf("ivu-icon-ios-arrow-forward") < 0 &&
        e.target.className.indexOf("ivu-carousel-arrow-hover") < 0
      ) {
        this.$emit("closePreview");
      }
    });
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style>
.ivu-carousel-list {
  top: 50% !important;
  transform: translateY(-50%) !important;
}
</style>
<style lang='less' scoped>
//@import url(); 引入公共css类
//轮播图样式
.carouselBox {
  z-index: 2000;
  background-color: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
/*.carousellist1{*/
/*top:50%;*/
/*transform: translateY(-50%);*/
/*}*/
.carousellist {
  width: 100%;
  height: 100%;
  /*padding-top:5%;*/
  position: relative;
}
.carousel_img {
  display: block;
  width: 50%;
  height: auto;
  margin: 0 auto;
}
</style>
